export class LadingSchesule {
    id: number;
    shipmentId: number;
    location: string;
    note: string;
    dateCreated: string;
    timeCreated: string;
    hubId: number;
    hubName: string;
    userId: number;
    userFullName: string;
    shipmentStatusId: number;
    shipmentStatusName: string;
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/ladingSchedule.model.ts